// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3QSqK","footerWrapper":"styles_footerWrapper__INQ7N","footer":"styles_footer__xo6jD","saveButton":"styles_saveButton__2gYNx"};